import React, { useEffect, useState } from "react";
import { Link } from "gatsby";
import Layout from "../components/layouts/layout";
import DataService from "../services/api/data_services";
import { BASE_SITE_URL } from "../shared/constants";
import "../components/clientsPage/index.scss";

// Industry images
import IndustryStartup from "../assets/Images/Industry/Industried_mobile/startup.png";
import IndustryHealthcare from "../assets/Images/Industry/Industried_mobile/healthcare.png";
import IndustryRetail from "../assets/Images/Industry/Industried_mobile/retail_ecommerce.png";
import IndustryFinance from "../assets/Images/Industry/Industried_mobile/finance.png";
import IndustryEducation from "../assets/Images/Industry/Industried_mobile/education.png";

// Startup client logos
import SliderImg1 from "../assets/Images/WhoWeWorkWith/clients/cake_by_mehwish_logo.png";
import SliderImg2 from "../assets/Images/WhoWeWorkWith/clients/cedar-medical-suppliers-logo.png";
import SliderImg3 from "../assets/Images/WhoWeWorkWith/clients/crash-vid-logo.png";
import SliderImg4 from "../assets/Images/WhoWeWorkWith/clients/dental-care-logo.png";
import SliderImg5 from "../assets/Images/WhoWeWorkWith/clients/don-logo.png";
import SliderImg6 from "../assets/Images/WhoWeWorkWith/clients/mic-computers-logo.png";
import SliderImg8 from "../assets/Images/WhoWeWorkWith/clients/plan-que-logo.png";
import SliderImg9 from "../assets/Images/WhoWeWorkWith/clients/reggie-logo.png";
import SliderImg10 from "../assets/Images/WhoWeWorkWith/clients/the-all-things-furniture-company-logo.png";

// Enterprise client logos
import ESliderImg1 from "../assets/Images/WhoWeWorkWith/enterprise/acuity-coaching-logo.png";
import ESliderImg2 from "../assets/Images/WhoWeWorkWith/enterprise/big-blue-hotel-logo.png";
import ESliderImg3 from "../assets/Images/WhoWeWorkWith/enterprise/channel-4-logo.png";
import ESliderImg4 from "../assets/Images/WhoWeWorkWith/enterprise/close-brothers-asset-management-logo.png";
import ESliderImg5 from "../assets/Images/WhoWeWorkWith/enterprise/gnc-live-well-logo.png";
import ESliderImg6 from "../assets/Images/WhoWeWorkWith/enterprise/hinch-property-management-logo.png";
import ESliderImg7 from "../assets/Images/WhoWeWorkWith/enterprise/NHS-Logo.png";
import ESliderImg8 from "../assets/Images/WhoWeWorkWith/enterprise/the-manchester-school-logo.png";
import ESliderImg9 from "../assets/Images/WhoWeWorkWith/enterprise/university-of-manchester-logo.png";
import ESliderImg10 from "../assets/Images/WhoWeWorkWith/enterprise/CERN-logo.png";

// Award images
import Award1 from "../assets/Images/WhoWeWorkWith/awards/Mobile-App-Developers-2020-award.png";
import Award2 from "../assets/Images/WhoWeWorkWith/awards/clutch-b2b-award.png";
import Award3 from "../assets/Images/WhoWeWorkWith/awards/mobile-app-daily-top-app-development-company-award.png";
import Award4 from "../assets/Images/WhoWeWorkWith/awards/digital-entrepreneur-awards.png";
import Award5 from "../assets/Images/WhoWeWorkWith/awards/clutch-top-100-companies.png";

import ogImage from "../assets/Images/ogImages/OG_Who-we-work.png";

const INDUSTRIES = [
  {
    img: IndustryStartup,
    title: "Startups",
    route: "/who-we-work-with/startups",
  },
  {
    img: IndustryHealthcare,
    title: "Healthcare",
    route: "/who-we-work-with/healthcare",
  },
  {
    img: IndustryRetail,
    title: "Retail & E-commerce",
    route: "/who-we-work-with/retail-and-e-commerce",
  },
  {
    img: IndustryFinance,
    title: "Finance",
    route: "/who-we-work-with/finance",
  },
  {
    img: IndustryEducation,
    title: "Education",
    route: "/who-we-work-with/education",
  },
];

const INDUSTRY_NAV = [
  { label: "Startups", route: "/who-we-work-with/startups" },
  { label: "Healthcare", route: "/who-we-work-with/healthcare" },
  {
    label: "Retail & E-commerce",
    route: "/who-we-work-with/retail-and-e-commerce",
  },
  { label: "Finance", route: "/who-we-work-with/finance" },
  { label: "Education", route: "/who-we-work-with/education" },
  { label: "Hospitality", route: "/who-we-work-with/hospitality" },
  {
    label: "Media & Publishing",
    route: "/who-we-work-with/media-and-publishing",
  },
  { label: "Public Sector", route: "/who-we-work-with/public-sector" },
  { label: "Not-For-Profit", route: "/who-we-work-with/not-for-profit" },
  {
    label: "Real Estate & PropTech",
    route: "/who-we-work-with/real-estate-and-proptech",
  },
];

const STARTUP_LOGOS = [
  { src: SliderImg1, alt: "Cake by Mehwish" },
  { src: SliderImg2, alt: "Cedar Medical Suppliers" },
  { src: SliderImg3, alt: "CrashVID" },
  { src: SliderImg4, alt: "Dental Care" },
  { src: SliderImg5, alt: "DON" },
  { src: SliderImg6, alt: "Mic Computers" },
  { src: SliderImg8, alt: "Plan Que" },
  { src: SliderImg9, alt: "Reggie" },
  { src: SliderImg10, alt: "The All Things Furniture Company" },
];

const ENTERPRISE_LOGOS = [
  { src: ESliderImg1, alt: "Acuity Coaching" },
  { src: ESliderImg2, alt: "Big Blue Hotel" },
  { src: ESliderImg3, alt: "Channel 4" },
  { src: ESliderImg4, alt: "Close Brothers Asset Management" },
  { src: ESliderImg5, alt: "GNC Live Well" },
  { src: ESliderImg6, alt: "Hinch Property Management" },
  { src: ESliderImg7, alt: "NHS" },
  { src: ESliderImg8, alt: "The Manchester School" },
  { src: ESliderImg9, alt: "University of Manchester" },
  { src: ESliderImg10, alt: "CERN" },
];

const AWARDS = [
  {
    img: Award1,
    title: "Top Mobile App Developers",
    sub: "3 consecutive years",
  },
  { img: Award2, title: "Top B2B Companies", sub: "4 consecutive years" },
  {
    img: Award3,
    title: "Top Cross-platform App Dev",
    sub: "4 consecutive years",
  },
  {
    img: Award4,
    title: "Digital Entrepreneur Awards",
    sub: "2 consecutive years",
  },
  {
    img: Award5,
    title: "Clutch Top 100 Companies",
    sub: "2 consecutive years",
  },
];

const WhoWeWorkWith = () => {
  const [page, setPage] = useState(1);
  const [clientStoryData, setClientStoryData] = useState([]);
  const [clientStoryRawData, setClientStoryRawData] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    DataService.getData(
      `admin/api/who-we-work?limit=6&page=${page}&type=Client%20Story&component=mini_view`,
    ).then((response) => {
      setClientStoryData((prev) => [...prev, ...response.data]);
      setClientStoryRawData(response);
      setIsLoading(false);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page]);

  const featuredStory = clientStoryData[0];
  const remainingStories = clientStoryData.slice(1);

  return (
    <Layout
      seo={{
        title: "Clients | DigiRyte",
        ogtitle: "Clients | DigiRyte",
        description:
          "DigiRyte partners with startups, scaleups, and enterprises across various industries to accelerate their digital capabilities and achieve scalable growth.",
        ogimage: ogImage,
        ogurl: `${BASE_SITE_URL}/who-we-work-with`,
        keywords:
          "startups, scaleups, enterprises, digital capabilities, scalable growth, industry partnerships",
      }}
    >
      {/* ============ 1. HERO ============ */}
      <section className="clh">
        <div className="clh__inner body-container">
          <span className="clh__eyebrow">Who We Work With</span>
          <h1 className="clh__title">Our Clients</h1>
          <p className="clh__sub">
            We partner with startups, scaleups, and enterprises across multiple
            industries to accelerate digital capabilities and create lasting
            impact.
          </p>
          <div className="clh__industries">
            {INDUSTRY_NAV.map((item) => (
              <Link
                key={item.route}
                to={item.route}
                className="clh__industry-pill"
              >
                {item.label}
              </Link>
            ))}
          </div>
          {/* <div className="clh__stats">
            {[
              { num: "150+", label: "Projects Delivered" },
              { num: "12+", label: "Industries Served" },
              { num: "9+", label: "Years of Excellence" },
              { num: "50+", label: "Expert Team Members" },
            ].map((s) => (
              <div key={s.label} className="clh__stat">
                <span className="clh__stat-num">{s.num}</span>
                <span className="clh__stat-label">{s.label}</span>
              </div>
            ))}
          </div> */}
        </div>
      </section>

      {/* ============ 2. INDUSTRY CARDS ============ */}
      <section className="cli">
        <div className="body-container">
          <div className="cli__header">
            <h2 className="cli__heading">
              Industries <span className="cli__heading-accent">We Serve</span>
            </h2>
            <p className="cli__sub">
              From early-stage startups to global enterprises, we deliver
              digital solutions that drive measurable results.
            </p>
          </div>
        </div>
        <div className="cli__grid">
          {INDUSTRIES.map((item) => (
            <Link key={item.route} to={item.route} className="cli__card">
              <img src={item.img} alt={item.title} className="cli__card-img" />
              <div className="cli__card-overlay">
                <p className="cli__card-title">{item.title}</p>
                <span className="cli__card-arrow">Explore &rarr;</span>
              </div>
            </Link>
          ))}
        </div>
      </section>

      {/* ============ 3. CASE STUDIES ============ */}
      {clientStoryData.length > 0 && (
        <section className="clc">
          <div className="body-container">
            <div className="clc__header">
              <h2 className="clc__heading">
                Client <span className="clc__heading-accent">Case Studies</span>
              </h2>
              <span className="clc__count">
                {clientStoryData.length} case stud
                {clientStoryData.length !== 1 ? "ies" : "y"} available
              </span>
            </div>

            {/* Featured first card */}
            {featuredStory && (
              <a
                href={`/client-story/${featuredStory.slug}/`}
                className="clc__featured"
              >
                {featuredStory.og_image && (
                  <div className="clc__featured-img-wrapper">
                    <img
                      src={featuredStory.og_image}
                      alt={featuredStory.title}
                      className="clc__featured-img"
                    />
                  </div>
                )}
                <div className="clc__featured-content">
                  <span className="clc__featured-badge">
                    <svg
                      width="12"
                      height="12"
                      viewBox="0 0 24 24"
                      fill="currentColor"
                      aria-hidden="true"
                    >
                      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                    </svg>
                    Featured Case Study
                  </span>
                  {featuredStory.article_tag && (
                    <span className="clc__featured-tag">
                      {featuredStory.article_tag}
                    </span>
                  )}
                  <h3 className="clc__featured-title">{featuredStory.title}</h3>
                  {featuredStory.og_description && (
                    <p className="clc__featured-desc">
                      {featuredStory.og_description}
                    </p>
                  )}
                  <span className="clc__featured-read">
                    Read Case Study
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2.2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      aria-hidden="true"
                    >
                      <line x1="5" y1="12" x2="19" y2="12" />
                      <polyline points="12 5 19 12 12 19" />
                    </svg>
                  </span>
                </div>
              </a>
            )}

            {/* Grid of remaining */}
            {remainingStories.length > 0 && (
              <div className="clc__grid">
                {remainingStories.map((story, i) => (
                  <a
                    key={story.slug || i}
                    href={`/client-story/${story.slug}/`}
                    className="clc__card"
                  >
                    {story.og_image && (
                      <div className="clc__card-img-wrapper">
                        <img
                          src={story.og_image}
                          alt={story.title}
                          className="clc__card-img"
                        />
                      </div>
                    )}
                    <div className="clc__card-content">
                      {story.article_tag && (
                        <span className="clc__card-tag">
                          {story.article_tag}
                        </span>
                      )}
                      <h3 className="clc__card-title">{story.title}</h3>
                      {story.og_description && (
                        <p className="clc__card-desc">{story.og_description}</p>
                      )}
                      <span className="clc__card-read">Read Case Study →</span>
                    </div>
                  </a>
                ))}
              </div>
            )}

            {clientStoryRawData.has_more && (
              <div className="clc__load-more">
                <button
                  className="clc__load-more-btn"
                  onClick={() => setPage((p) => p + 1)}
                  disabled={isLoading}
                >
                  {isLoading ? "Loading..." : "Load More Case Studies"}
                </button>
              </div>
            )}
          </div>
        </section>
      )}

      {/* ============ 4. CLIENT LOGOS ============ */}
      <section className="cll">
        <div className="body-container">
          <div className="cll__section">
            <p className="cll__label">Startup Clients</p>
            <h2 className="cll__heading">
              Key <span className="cll__heading-accent">Start-up</span> Clients
            </h2>
            <div className="cll__grid">
              {STARTUP_LOGOS.map((logo) => (
                <div key={logo.alt} className="cll__logo">
                  <img src={logo.src} alt={logo.alt} />
                </div>
              ))}
            </div>
          </div>

          <div className="cll__section">
            <p className="cll__label">Enterprise Clients</p>
            <h2 className="cll__heading">
              Key <span className="cll__heading-accent">Enterprise</span>{" "}
              Clients
            </h2>
            <div className="cll__grid">
              {ENTERPRISE_LOGOS.map((logo) => (
                <div key={logo.alt} className="cll__logo">
                  <img src={logo.src} alt={logo.alt} />
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* ============ 5. AWARDS ============ */}
      <section className="cla">
        <div className="body-container">
          <div className="cla__header">
            <span className="cla__eyebrow">Recognition</span>
            <h2 className="cla__heading">Awards &amp; Recognitions</h2>
            <p className="cla__sub">
              Driven by an endless passion for technology, DigiRyte is making
              progress in shaping the app economy.
            </p>
          </div>
          <div className="cla__grid">
            {AWARDS.map((award) => (
              <div key={award.title} className="cla__award">
                <div className="cla__award-img-wrap">
                  <img src={award.img} alt={award.title} />
                </div>
                <p className="cla__award-title">{award.title}</p>
                <p className="cla__award-sub">{award.sub}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ============ 6. CTA STRIP ============ */}
      <section className="clb">
        <div className="body-container clb__inner">
          <div className="clb__text">
            <h2 className="clb__heading">Ready to Build Something Great?</h2>
            <p className="clb__sub">
              Let&apos;s talk about how DigiRyte can accelerate your digital
              transformation.
            </p>
          </div>
          <a href="/contact-us" className="clb__btn">
            Get in Touch
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.2"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden="true"
            >
              <line x1="5" y1="12" x2="19" y2="12" />
              <polyline points="12 5 19 12 12 19" />
            </svg>
          </a>
        </div>
      </section>
    </Layout>
  );
};

export default WhoWeWorkWith;
